import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d58aa838"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "default_box" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No content here", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: 'https://image.kilimall.com/kenya/wap/common/null_bg.png'.webpFilters()
,
      alt: ""
    }, null, 8, _hoisted_2),
    _hoisted_3
  ]))
}